import { nanoid } from 'nanoid';
import { SYSTEM_SCREEN as SystemScreenType } from '../../../../../poll';

export function generateSystemScreen(
  overrides: Partial<SystemScreenType['data']> = {},
  cause: SystemScreenType['data']['cause'],
): SystemScreenType {
  return {
    id: nanoid(10),
    data: {
      cause,
      type: 'SYSTEM_SCREEN',
      alignContent: 'center',
      cta: undefined,
      ctaUrl: undefined,
      title: '',
      text: '',
      image: undefined,
      ...overrides,
    },
  };
}
